import { useEffect } from 'react';
import { preloadCriticalImages } from '../../utils/ImageOptimizer';

interface ImagePreloaderProps {
    images: string[];
    children?: React.ReactNode;
}

/**
 * Component to preload critical images for better user experience
 * Typically used at the app root to preload important above-the-fold images
 */
const ImagePreloader = ({ images, children }: ImagePreloaderProps) => {
    useEffect(() => {
        if (images && images.length > 0) {
            // Only preload in production to avoid unnecessary network requests during development
            if (process.env.NODE_ENV === 'production') {
                preloadCriticalImages(images);
            }
        }
    }, [images]);

    return <>{children}</>;
};

/**
 * Critical images that should be preloaded for optimal performance
 * These are typically images that are shown immediately on page load
 */
export const CRITICAL_IMAGES = [
    '/assets/cover-optimized.jpg',
    '/assets/background-optimized.jpg'
];

export default ImagePreloader; 